// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  type: "development",
  version:"1.1.2",
  apiUri: "https://teamsxrmreceiverfa-dev.azurewebsites.net",
  apiCode: "?code=qD5LhGhftj_seIdIqpLZpdI6MNPO4vPoLAMZt0QSp8-1AzFuZSGKPQ==",
  basicConfQuery: "/api/ClientViewBasicSetting",
  acsConfQuery: "/api/v1.0/ACSToken",
  connectorConfQuery: "/api/v1.0/CRMConnectors",
  connectorAuthQuery: "/api/v1.0/AuthConfigs",
  telemetryConfQuery: "/api/v1.0/stats/ClientVersion",
  msConfig: {
    clientId: '405e6f6a-10f0-4ee7-a66d-4aa5b14708ac', // Application (client) ID from the app registration
    authority: 'https://login.microsoftonline.com/common/v2.0', // The Azure cloud instance and the app's sign-in audience (tenant ID, common, organizations, or consumers)
    redirectUri: 'https://devclientview.xrmfusion.cloud/callback',// This is your redirect URI,
  },
  GRAPH_ENDPOINT: "https://graph.microsoft.com/v1.0",
  GRAPH_PROFILE_PICTURE: "/me/photo/$value",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
